import { render, staticRenderFns } from "./New.vue?vue&type=template&id=5ad82901&scoped=true&lang=pug&"
import script from "./New.vue?vue&type=script&lang=ts&"
export * from "./New.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad82901",
  null
  
)

export default component.exports